import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { SettingsProvider } from "./context/SettingsContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ThemeInjector from "./components/ThemeInjector";
import Marquee from "./components/Marquee";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import Page from "./pages/Page";
import ProductDetail from "./pages/ProductDetail";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[var(--brand-bg)]">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <CartProvider>
              <ThemeInjector />
              <Marquee />
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/page/:slug" element={<Page />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-center" richColors />
            </CartProvider>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
